/* istanbul ignore file */
import React from 'react';
import { TRACKING } from 'common/constants/constants';
import timeDistributionMetricsCTA from 'images/timeDistributionMetricsCTA.svg';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  TIME_DISTRIBUTION: 'TIME_DISTRIBUTION',
  TABLE: 'TABLE'
};

const TEXTS = {
  [SECTION_TYPES.TIME_DISTRIBUTION]:
    'Pinpoint where you’re bottlenecked so you can fix' +
    ' processes faster with cumulative time distribution' +
    ' visibility across boards, states, and iterations for' +
    ' the entire organization or on a per-team basis',
  [SECTION_TYPES.TABLE]:
    'Uncover where your issues are getting bogged down' +
    ' by looking at your time distribution data in a bar' +
    ' chart visualization or table view–whichever you find most helpful'
};

const TimeDistributionCta = () => (
  <CtaPage
    textsMap={TEXTS}
    page={TRACKING.PAGES.METRICS}
    pageTab={TRACKING.PAGE_TABS.TIME_DISTRIBUTION}
    buttonLineProps={{
      textWidth: '70%',
      leftText: 'Unlock Time distribution dashboard to see!'.toUpperCase(),
      buttonText: 'BOOK A DEMO NOW'
    }}
    backgroundImage={timeDistributionMetricsCTA}
    sections={[
      {
        sectionType: SECTION_TYPES.TIME_DISTRIBUTION,
        buttonPosition: {
          left: '43%',
          top: '14rem'
        },
        coverProps: {
          height: '30rem',
          width: '100%'
        },
        textPosition: {
          left: TEXT_POSITION,
          top: '14rem'
        },
        isTextLeft: true
      },
      {
        sectionType: SECTION_TYPES.TABLE,
        buttonPosition: {
          left: '35%',
          top: '40rem'
        },
        coverProps: {
          height: '20rem',
          width: '100%',
          position: { right: 0, top: '30rem' }
        },
        textPosition: {
          right: TEXT_POSITION,
          top: '35rem'
        }
      }
    ]}
  />
);

export default TimeDistributionCta;
